import { ActionIcon, Divider, Group, Paper, Text } from "@mantine/core";
import { useState } from "react";
import { RiErrorWarningLine } from "react-icons/ri";
import { AiOutlineClose } from "react-icons/ai";

const ToastBanner = ({ title }: { title: string }) => {
  const [hideBanner, setHideBanner] = useState(false);

  return hideBanner ? null : (
    <>
      <Divider />
      <Paper
        sx={(theme) => ({
          margin: 20,
          marginBottom: 10,
          padding: 10,
          borderRadius: 15,
          verticalAlign: "middle",
          backgroundColor:
            theme.colorScheme === "dark"
              ? "rgba(207, 156, 74, 0.1)"
              : "rgb(255, 246, 235)",
          borderColor:
            theme.colorScheme === "dark"
              ? "rgba(207, 140, 74, 0.3)"
              : "rgb(235, 195, 142)",
          borderWidth: "1px",
          borderStyle: "solid",
        })}
      >
        <Group position="apart">
          <Group
            sx={{
              paddingLeft: 10,
            }}
          >
            <RiErrorWarningLine />

            <Group spacing={5}>
              <Text size={"sm"}>{title}</Text>
            </Group>
          </Group>
          <ActionIcon
            onClick={() => {
              setHideBanner(true);
            }}
            sx={{
              ":hover": {
                color: "44b7d6",
              },
            }}
          >
            <AiOutlineClose />
          </ActionIcon>
        </Group>
      </Paper>
    </>
  );
};

export default ToastBanner;
